"use client";

import type { LeadFlowPhoneCta } from "@homeinstead/schemas";

import Phone from "@homeinstead/icons/Phone";
import { formatPhoneDisplay } from "@homeinstead/shared";
import { cn } from "@homeinstead/ui";
import { Button } from "@homeinstead/ui/components/Button";
import Image from "next/image";
import { TrackedPhoneLink } from "~www/components/TrackedPhoneLink";
import { getButtonVariant } from "../../utils/get-button-variant";
import { useLeadFlowRuntime } from "../LeadFlowRuntimeContext";

const DEFAULT_LABEL = "Call Us: {{phoneNumber}}";

type PhoneCtaItemProps = {
  item: {
    customIconUrl?: string | null;
    icon?: LeadFlowPhoneCta["icon"] | null;
    label?: string | null;
  };
};

function PhoneCtaItem({ item }: PhoneCtaItemProps) {
  const { phoneNumber, themeContrast } = useLeadFlowRuntime();

  const label = (item.label || DEFAULT_LABEL).replaceAll(
    "{{phoneNumber}}",
    formatPhoneDisplay(phoneNumber),
  );
  const showPhoneIcon = item.icon === "phone";
  const customIconUrl =
    item.icon === "custom" && item.customIconUrl ? item.customIconUrl : null;

  return (
    <Button
      asChild
      className={cn("w-full", { "gap-2": showPhoneIcon || customIconUrl })}
      variant={getButtonVariant(themeContrast)}
    >
      <TrackedPhoneLink
        className="no-underline"
        phoneNumber={phoneNumber}
        placement="lead form"
        size="inline"
        variant="plain"
      >
        {showPhoneIcon ? <Phone className="fill-current" /> : null}
        {customIconUrl ? (
          <>
            <Image
              alt=""
              className="size-5"
              height={20}
              src={customIconUrl}
              width={20}
            />
            <span>{label}</span>
          </>
        ) : (
          label
        )}
      </TrackedPhoneLink>
    </Button>
  );
}

export { PhoneCtaItem };
